document.querySelectorAll('.date input').forEach(input => {
    input.addEventListener('change', () => {
        toggleDateLabel(input);
    });

    input.addEventListener('focus', () => {
        toggleDateLabel(input);
    });

    input.addEventListener('focusout', () => {
        toggleDateLabel(input);
    });
});

function toggleDateLabel(input) {
    const container = input.closest('.date')
    console.log(document.activeElement)
    if (input.value || document.activeElement == input) {
        container.classList.add('has-value');
    } else {
        container.classList.remove('has-value');
    }
}

const reset = document.querySelector('.agenda-filter .reset');
if (reset) {
    reset.addEventListener('click', (e) => {
        e.preventDefault();
        const form = reset.closest('form');
        form.querySelectorAll('input, select').forEach(input => {
            input.value = '';
        });
        form.submit();
    });
}

